import React, {FunctionComponent} from 'react';
import "./footer.scss";
import Content from "../Content/Content";
import maestro from "../../assets/logo_Maestro.svg";
import mastercard from "../../assets/Logo_Mastercard.svg";
import visa from "../../assets/Logo_Visa.svg";
import revolut from "../../assets/Logo_Revolut.svg";
import toppay from "../../assets/Logo_Toppay.svg";
import paysafe from "../../assets/Logo_Paysafecard.svg";
import magnum from "../../assets/Logo_Magnum.agentie.svg";
import {ReadMore} from "../ReadMore/ReadMore";

import over18 from "../../assets/icon 18+.svg";
import onjn from "../../assets/icon.ONJN.png";
import Anchor from "../Anchor";

const Footer:FunctionComponent = () => {
    return (
        <footer className="footer-container">
            <Content className={"footer-content"}>
                <div className="footer-item">
                    <div className="title">
                        DESPRE NOI
                    </div>

                    <div className="text-content">
                        <div>
                            <ReadMore maxChars={650}>
                                Platforma MAGNUM oferă jucătorilor o combinație inspirată între o agenție de pariuri
                                sportive online și un casino online, ambele fiind integrate printr-o platforma
                                securizata de ultimă generație.

                                Oferta de pariere MAGNUMBET include pariuri sportive, pariuri LIVE, pariuri pe numere –
                                LOTO, pariuri virtuale și altele. Totodată, pe MAGNUMBET pasionații jocurilor de casino
                                online beneficiază de o ofertă excelentă la depunere, cu sute de rotiri și bani bonus.
                            </ReadMore>
                        </div>

                    </div>

                </div>
                <div className="footer-item">
                    <div className="title">
                        LINKURI UTILE
                    </div>

                    <div className="footer-links">
                        <Anchor href="https://magnumbet.ro/info/privacy-policy">Politica de confidențialitate</Anchor>
                        <Anchor href="https://magnumbet.ro/info/responsible-gambling">Joc responsabil</Anchor>
                        <Anchor href="https://magnumbet.ro/info/terms-conditions">Termeni și condiții</Anchor>
                        <Anchor href="https://magnumbet.ro/info/bonus-terms">Condițiile bonusului</Anchor>
                        <Anchor href="https://magnumbet.ro/info/banking">Casierie</Anchor>
                        <Anchor href="https://magnumbet.ro/info/faq">Întrebări frecvente</Anchor>
                        <Anchor href="https://magnumbet.ro/info/optiuni-pariuri-sportive">Ofertă de pariuri</Anchor>
                        <Anchor href="https://magnumbet.ro/info/regulament-general-pariuri">Regulament pariuri</Anchor>
                        <Anchor href="https://magnumbet.ro/info/support">Asistență</Anchor>
                    </div>

                </div>
                <div className="footer-item">
                    <div className="title">
                        METODE DE PLATĂ
                    </div>
                    <div className="footer-images">
                        <img src={maestro} alt="payment method"/>
                        <img src={mastercard} alt="payment method"/>
                        <img src={visa} alt="payment method"/>
                        <img src={revolut} alt="payment method"/>
                        <img src={toppay} alt="payment method"/>
                        <img src={paysafe} alt="payment method"/>
                        <img src={magnum} alt="payment method"/>
                    </div>
                </div>
            </Content>
            <div className="footer-copyright">
                <Content className={"footer-copyright-content"}>

                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72">
                            <g id="icon_18_" data-name="icon 18+" transform="translate(-116 -5328)">
                                <g id="Ellipse_571" data-name="Ellipse 571" transform="translate(116 5328)" fill="none" stroke="#5b5c5f" stroke-width="2">
                                    <circle cx="36" cy="36" r="36" stroke="none"/>
                                    <circle cx="36" cy="36" r="35" fill="none"/>
                                </g>
                                <text id="_18_" data-name="18+" transform="translate(128 5376)" fill="#5b5c5f" font-size="30" font-family="OpenSans-Bold, Open Sans" font-weight="700" letter-spacing="-0.05em"><tspan x="0" y="0">18+</tspan></text>
                            </g>
                        </svg>
                        <img src={onjn} alt="onjn"/>
                    </div>


                    <div>
                        Site-ul MAGNUMBET.RO este deținut și operat de către Crowd Entertainment Ltd., societate
                        înmatriculată conform legii societăţilor comerciale din Malta , cu sediul social în Malta, 2
                        Spinola Road, St. Julians STJ 3014, numar de inregistrare C 97517. Licența nr. L1213823W001269 ,
                        emisă de Comitetul de Supraveghere din cadrul O.N.J.N., valabilă din data de 01.03.2021 până la
                        data de 28.02.2031. Cod unic de identificare fiscală 43557448, eliberat de Administrația Fiscală
                        pentru Contribuabili Nerezidenți. Accesul la site-urile online cu jocuri pe bani reali este
                        interzis în conformitate cu unele legislații naționale. Este responsabilitatea fiecărui jucător
                        în parte de a se asigura că acționează în conformitate cu legislația în vigoare atunci când
                        accesează site-ul MAGNUMBET.RO. Jocurile de noroc implică riscuri financiare și de dependență.
                        Jucați cu moderație.
                    </div>
                </Content>
            </div>
        </footer>
    );
}

export default Footer;